export function matchesSelection<Value>(
  value: Value,
  selected: Value[],
): boolean {
  return selected.length === 0 || selected.includes(value);
}
